import { TextField } from '@boltenergy-be/design-system'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'next-i18next'
import { NO_NUMBERS } from 'constants/regex'
import { InputProps } from 'components/inputs/types'
import { getFieldError, getFieldName } from 'components/inputs/utils'

const LastName = ({ hiddenLabel, parentDotPath, required = true }: InputProps) => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  return (
    <TextField
      {...register(getFieldName('lastName', parentDotPath), {
        maxLength: {
          value: 40,
          message: t('validation:max.string', {
            attribute: t('commonFormFields:lastName'),
            length: 40
          })
        },
        required: {
          value: required,
          message: t('validation:required')
        },
        pattern: {
          value: NO_NUMBERS,
          message: t('validation:noNumbers', {
            attribute: t('commonFormFields:lastName')
          })
        }
      })}
      error={getFieldError('lastName', parentDotPath, errors)?.message}
      label={t('commonFormFields:lastName')}
      hiddenLabel={hiddenLabel}
    />
  )
}

export default LastName
